jQuery(document).ready(function (jQuery) {
    //Slider principal
    jQuery('.slider-principal').owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        items: 1,
        navText: ['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>']
    });

    jQuery('.carrosel-frota').owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        items: 1,
        navText: ['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>']
    });


    jQuery('.ico-busca-geral a').click(function(event) {
        event.preventDefault();
        var checkout = jQuery('.busca-abr-box');
        if ( jQuery(checkout).is(':hidden ') ) {
            jQuery(checkout).removeClass('fadeOut');
            jQuery(checkout).show().addClass('fadeIn');
            setTimeout(function() {
                jQuery('.busca-box').addClass('slideInDown');
            }, 500);
        } else {
            jQuery(checkout).removeClass('fadeIn');
            jQuery(checkout).addClass('fadeOut');
            setTimeout(function() {
                jQuery(checkout).css({display: ''});
                jQuery('.busca-box').removeClass('slideInDown');
            }, 800);
        }
    });

    jQuery('.menu-responsivo a').click(function(event) {
        event.preventDefault();
        jQuery('.header-focus').toggleClass('active');
        var menuresponsivo = jQuery('.mobile-menu-topo');
        if ( jQuery(menuresponsivo).is(':hidden ') ) {
            jQuery(menuresponsivo).removeClass('slideOutRight');
            jQuery(menuresponsivo).show().addClass('slideInRight');
        } else {
            jQuery(menuresponsivo).removeClass('slideInRight');
            jQuery(menuresponsivo).addClass('slideOutRight');
            setTimeout(function() {
                jQuery(menuresponsivo).css({display: ''});
            }, 800);
        }
    });

    //ativando galeria fotos
    jQuery('[data-fancybox="images"]').fancybox({
        afterLoad: function (instance, current) {
            var pixelRatio = window.devicePixelRatio || 1;

            if (pixelRatio > 1.5) {
                current.width = current.width / pixelRatio;
                current.height = current.height / pixelRatio;
            }
        }
    });
    jQuery("#rigging").on('click', function () {
        jQuery.fancybox.open([
            {
                src: '../wp-content/themes/focuslog/assets/images/rigging/01.png',
                opts: {
                    caption: 'Rigging'
                }
            },
            {
                src: '../wp-content/themes/focuslog/assets/images/rigging/02.png',
                opts: {
                    caption: 'Rigging'
                }
            },
            {
                src: '../wp-content/themes/focuslog/assets/images/rigging/03.png',
                opts: {
                    caption: 'Rigging'
                }
            },
            {
                src: '../wp-content/themes/focuslog/assets/images/rigging/04.png',
                opts: {
                    caption: 'Rigging'
                }
            },
            {
                src: '../wp-content/themes/focuslog/assets/images/rigging/05.jpg',
                opts: {
                    caption: 'Rigging'
                }
            }

        ], {
            thumbs: {
                autoStart: true,
                axis: 'y'
            },
            loop: true
        });

    });

    jQuery("#transportes").on('click', function () {
        jQuery.fancybox.open([
            {
                src: '../wp-content/themes/focuslog/assets/images/transporte/01.png',
                opts: {
                    caption: 'Transporte'
                }
            },
            {
                src: '../wp-content/themes/focuslog/assets/images/transporte/02.png',
                opts: {
                    caption: 'Transporte'
                }
            },
            {
                src: '../wp-content/themes/focuslog/assets/images/transporte/03.png',
                opts: {
                    caption: 'Transporte'
                }
            }

        ], {
            thumbs: {
                autoStart: true,
                axis: 'y'
            },
            loop: true
        });

    });


    jQuery("#automotivo").on('click', function () {
        jQuery.fancybox.open([
            {
                src: '../wp-content/themes/focuslog/assets/images/automotivo/01.jpg',
                opts: {
                    caption: 'Automotivo'
                }
            },
            {
                src: '../wp-content/themes/focuslog/assets/images/automotivo/02.jpg',
                opts: {
                    caption: 'Automotivo'
                }
            },
            {
                src: '../wp-content/themes/focuslog/assets/images/automotivo/03.jpg',
                opts: {
                    caption: 'Automotivo'
                }
            }

        ], {
            thumbs: {
                autoStart: true,
                axis: 'y'
            },
            loop: true
        });

    });

    jQuery("#healthcare").on('click', function () {
        jQuery.fancybox.open([
            {
                src: '../wp-content/themes/focuslog/assets/images/healthcare/01.jpg',
                opts: {
                    caption: 'Healthcare'
                }
            },
            {
                src: '../wp-content/themes/focuslog/assets/images/healthcare/02.jpg',
                opts: {
                    caption: 'Healthcare'
                }
            },
            {
                src: '../wp-content/themes/focuslog/assets/images/healthcare/03.jpg',
                opts: {
                    caption: 'Healthcare'
                }
            },
            {
                src: '../wp-content/themes/focuslog/assets/images/healthcare/04.jpg',
                opts: {
                    caption: 'Healthcare'
                }
            },
            {
                src: '../wp-content/themes/focuslog/assets/images/healthcare/05.jpg',
                opts: {
                    caption: 'Healthcare'
                }
            }

        ], {
            thumbs: {
                autoStart: true,
                axis: 'y'
            },
            loop: true
        });

    });

    jQuery("*[rel=tooltipText]").hover(function(e){
        e.preventDefault();
        jQuery("body").append('<div class="tooltip-text">'+jQuery(this).attr('alt')+'</div>');
        jQuery('.tooltip-text').css({top : e.pageY - 40,left : e.pageX + 10}).fadeIn();

    }, function(){
        jQuery('.tooltip-text').remove();
    });
    jQuery("*[rel=tooltipText]").click(function(e){
        e.preventDefault();
    });
});